export default class FiltroTitulos {
    constructor () {
        this.DataEmissaoInicio = '';
        this.DataEmissaoTermino = '';
        this.DataVencimentoInicio = '';
        this.DataVencimentoTermino = '';
        this.DataBaixaInicio = '';
        this.DataBaixaTermino = '';
        this.NumeroNotaFiscal = undefined;
        this.NumeroTitulo = undefined;
        this.ClienteId = undefined;
        this.EmpresaId = undefined;
        this.SituacaoDocumento = undefined;
        this.TipoDocumento = undefined;
        this.TipoEmissao = undefined;
        this.ComponentesExpandidos = undefined;
        this.DadosClienteAgrupador = undefined;
        this.RepresentanteId = undefined;
    }
}